<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="1200px"
    top="5vh"
    :close-on-click-modal="false"
    class="page-dialog activity-create-dialog"
    append-to-body
    @close="handleClose"
  >
    <div class="dialog-body-scroll">
      <el-form
        ref="formRef"
        :model="localForm"
        :rules="formRules"
        label-position="right"
        label-width="120px"
        size="mini"
      >
        <div class="section-head">配置信息</div>
        <el-row :gutter="16">
          <el-col v-if="actType !== ACT_TYPE_LINK" :span="12">
            <el-form-item label="活动标题" prop="title" required>
              <LanguageInput
                v-model="localForm.title"
                :lang.sync="localForm.desc_lang"
                placeholder="请输入标题"
                :maxlength="128"
                :show-word-limit="true"
                clearable
                style="width: 350px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="actType === ACT_TYPE_LINK ? 10 : 12">
            <el-form-item label="活动类型" prop="actType">
              <el-select v-model="localForm.actType" style="width: 240px" :disabled="props.mode === 'edit'">
                <el-option
                  v-for="opt in ACT_TYPE_OPTIONS"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                  :disabled="
                    (opt.value === 2 && props.hasRedEnvelopeRain) ||
                    (opt.value === 4 && props.hasSignIn) ||
                    (opt.value === 6 && props.hasAgentRewardBox) ||
                    (opt.value === 7 && props.hasLossCashback) ||
                    (opt.value === 8 && props.hasTotalDepositReward) ||
                    (opt.value === 9 && props.hasFirstDepositReward) ||
                    (opt.value === 1 && props.hasSpinLuck)
                  "
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="actType !== ACT_TYPE_LINK" :gutter="24">
          <el-col :span="12">
            <el-form-item label="活动时间" prop="activityTimeRange" required>
              <div
                style="width: 340px"
                v-if="props.mode !== 'edit' || (activityData?.start_at === -1 && activityData?.end_at === -1)"
              >
                <DateTimeRangePicker v-model="localForm.activityTimeRange" />
              </div>
              <div v-else>
                <span>{{ activityData?.activityTimeRangeText }}</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 首次存款奖励展示时间（时间范围） -->
        <el-row v-if="actType === 9" :gutter="24">
          <el-col :span="12">
            <el-form-item label="展示时间" prop="displayTimeRange" required>
              <div style="width: 340px" v-if="props.mode !== 'edit'">
                <DateTimeRangePicker v-model="localForm.displayTimeRange" placeholder="请选择展示时间范围" />
              </div>
              <div v-else>
                <span>{{ activityData.displayTimeRangeText || '-' }}</span>
                <!-- <DateTimeRangePicker v-model="localForm.displayTimeRange" placeholder="请选择展示时间范围" /> -->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="活动状态" prop="status">
              <el-radio-group v-model="localForm.status">
                <el-radio :label="1">立即开启</el-radio>
                <el-radio :label="2">停用</el-radio>
              </el-radio-group>
              <span class="status-tip" style="margin-left: 10px">
                立即开启，将根据设定的活动时间判断，若活动周期为永久则马上开启活动
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="actType !== ACT_TYPE_LINK" :gutter="24">
          <el-col :span="6">
            <el-form-item label="奖励有效期" prop="reward_expire_days" required>
              <el-input-number
                :disabled="props.mode === 'edit'"
                v-model="localForm.reward_expire_days"
                :min="0"
                :precision="2"
                :controls="false"
                style="width: 100px"
                placeholder="中奖后多久有效"
              />
              <span class="status-tip" style="margin-left: 10px">天</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="活动排序" prop="sort">
              <el-input-number
                v-model="localForm.sort"
                :min="0"
                :precision="0"
                :controls="false"
                style="width: 80px"
                placeholder="请输入活动排序"
              />
              <span class="status-tip" style="margin-left: 10px">数字越大，活动越靠前</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="活动封面" prop="icon">
              <SingleImageUpload v-model="localForm.icon" :size="120" :allowed-types="['jpeg', 'jpg', 'png', 'gif']" />
            </el-form-item>
          </el-col>
        </el-row>

        <component
          v-if="currentTypeModule && currentTypeModule.component"
          :is="currentTypeModule.component"
          :local-form="localForm"
          :rule-flags="ruleFlags"
          :rule-values="ruleValues"
          :red-rule-flags="redRuleFlags"
          :red-rule-values="redRuleValues"
          :vip-options="vipOptions"
          @syncVipCheckAllState="syncVipCheckAllState"
          @onVipCheckAllChange="onVipCheckAllChange"
        />

        <div v-if="actType !== ACT_TYPE_LINK" class="section-head">活动说明</div>
        <el-form-item v-if="actType !== ACT_TYPE_LINK" label=" " label-width="0" prop="desc" class="desc-form-item">
          <LanguageTextarea
            v-model="localForm.desc"
            :lang.sync="localForm.desc_lang"
            :rows="6"
            placeholder="请输入活动说明"
            :maxlength="2000"
            :show-word-limit="true"
          />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="mini">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit" size="mini">确定</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
/* eslint-disable no-undef */
import DateTimeRangePicker from '@/components/DateTimeRangePicker'
import SingleImageUpload from '@/components/Upload/SingleImageUpload.vue'
import LanguageTextarea from '@/components/LanguageTextarea/index.vue'
import LanguageInput from '@/components/LanguageInput/index.vue'
import { ACT_TYPE_OPTIONS } from '../const'
import { ACT_TYPE_LINK } from './activity-types'
import { useActivityCreateDialog } from './useActivityCreateDialog'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  mode: {
    type: String,
    default: 'create',
  },
  activityData: {
    type: Object,
    default: null,
  },
  hasRedEnvelopeRain: {
    type: Boolean,
    default: false,
  },
  hasSignIn: {
    type: Boolean,
    default: false,
  },
  hasAgentRewardBox: {
    type: Boolean,
    default: false,
  },
  hasSpinLuck: {
    type: Boolean,
    default: false,
  },
  hasLossCashback: {
    type: Boolean,
    default: false,
  },
  hasTotalDepositReward: {
    type: Boolean,
    default: false,
  },
  hasFirstDepositReward: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:visible', 'success'])

const {
  formRef,
  submitting,
  dialogTitle,
  vipOptions,
  localForm,
  actType,
  currentTypeModule,
  ruleFlags,
  ruleValues,
  redRuleFlags,
  redRuleValues,
  formRules,
  syncVipCheckAllState,
  onVipCheckAllChange,
  handleClose,
  handleSubmit,
} = useActivityCreateDialog(props, emit)
</script>

<style lang="scss">
.activity-create-dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px 0;
    max-height: calc(100vh - 160px);
    overflow: hidden;
  }
}

.dialog-body-scroll {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  width: 100%;
  padding-right: 4px;
  overflow-x: hidden;
}

.section-head {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin: 16px 0 12px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  line-height: 1.2;
}

.form-item-vips {
  align-items: flex-start;
}

.vips-wrap {
  width: 100%;
}

.vips-group {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.desc-form-item ::v-deep .el-form-item__content {
  margin-left: 0 !important;
}

.desc-lang-switch {
  margin-bottom: 10px;
}

.status-tip {
  font-size: 12px;
  color: #999;
}
::v-deep .el-row {
  margin-left: 0;
  margin-right: 0;
}
</style>
